import Opportunity from './Opportunity.page';

export default Opportunity;